/* =========================================================================
   TBB NATIVE SCROLL-SNAP CAROUSEL — arrow wiring only
   =========================================================================
   The scrolling itself is 100% native (CSS scroll-snap on .tbb-ns-track):
   phone touch, Mac trackpad, and keyboard all work with zero JS. This file
   ONLY powers the prev/next arrow buttons (desktop affordance) and keeps
   their disabled state in sync with scroll position. No momentum, no
   setTranslate, no rAF loop — the things that caused the old jank.

   Markup contract (sections/ai-carousel.liquid):
     [data-tbb-native-carousel]
       [data-tbb-ns-prev]  (button)
       [data-tbb-ns-track] (the scroller; children are .tbb-ns-slide)
       [data-tbb-ns-next]  (button)

   It auto-wires on load AND re-wires after the AI engine swaps in new picks
   (MutationObserver + a global hook ai-carousel.js calls). Idempotent.
   ========================================================================= */
(function () {
  'use strict';

  // One card's scroll distance = slide width + gap. Falls back to 80% of the
  // viewport width if no slide is measurable yet.
  function cardStep(track) {
    var slide = track.querySelector('.tbb-ns-slide');
    if (!slide) return Math.round(track.clientWidth * 0.8);
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return Math.round(slide.getBoundingClientRect().width + gap);
  }

  // Grey out an arrow when there's nothing more to scroll that way. The buttons
  // carry .swiper-button-prev/next, so styling (incl. the disabled look) comes
  // from the global carousel-nav rule — which keys off `.swiper-button-disabled`.
  // We toggle that class (and the `disabled` attribute for accessibility).
  function setDisabled(el, off) {
    if (!el) return;
    el.disabled = off;
    el.classList.toggle('swiper-button-disabled', off);
  }
  function syncNav(root, track) {
    var prev = root.querySelector('[data-tbb-ns-prev]');
    var next = root.querySelector('[data-tbb-ns-next]');
    var max = track.scrollWidth - track.clientWidth - 2; // -2 for sub-pixel slack
    setDisabled(prev, track.scrollLeft <= 2);
    setDisabled(next, track.scrollLeft >= max);
  }

  function wire(root) {
    if (root.dataset.tbbNsWired) return;
    var track = root.querySelector('[data-tbb-ns-track]');
    if (!track) return;
    root.dataset.tbbNsWired = '1';

    var prev = root.querySelector('[data-tbb-ns-prev]');
    var next = root.querySelector('[data-tbb-ns-next]');

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(track), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () { syncNav(root, track); }, { passive: true });
    window.addEventListener('resize', function () { syncNav(root, track); }, { passive: true });
    syncNav(root, track);
  }

  function wireAll() {
    document.querySelectorAll('[data-tbb-native-carousel]').forEach(wire);
  }

  // ai-carousel.js calls this after replacing [data-ai-content] with engine picks.
  window.tbbWireNativeCarousels = wireAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  // Catch carousels that hydrate/swap in after first paint (engine swap).
  var observer = new MutationObserver(wireAll);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 30000);
})();
